module.exports = __webpack_public_path__ + "img/2.913a6eaf.jpg";